/* component to output a form as a modal / pop-up */

import ReactDOM from "react-dom";
import React, { useState, useEffect } from "react";
import "./formModal.css";
import PopUpSuccessMessageModal from "../formSubmissionSuccessMessageModal/popUpSuccessMessageModal";

const PopUpModal = ({
  children,
  activeForm,
  formActiveState,
  setFormActiveState,
}) => {
  const [showSuccessFormMessage, setShowSuccessFormMessage] = useState(false);
  const [successForm, setSuccessForm] = useState("");

  const handleClose = () => {
    setFormActiveState(false);
  };

  const handleSuccess = (formSubmitted) => {
    setSuccessForm(formSubmitted);
    setShowSuccessFormMessage(true);
    console.log("HIT SCORECARD DOWNLOAD", formSubmitted);
    if (
      formSubmitted === "download" ||
      formSubmitted === "scorecard-download"
    ) {
      const link = document.createElement("a");
      link.href =
        "/assets/content/CommunityWildfireResilienceScorecard-02-20-24v03b.zip";
      link.download = "CommunityWildfireResilienceScorecard-02-20-24v03b.zip";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    setFormActiveState(false);
  };

  const handleError = () => {
    setSuccessForm("error");
    setShowSuccessFormMessage(true);
    setFormActiveState(false);
  };

  const formModal = (
    <>
      {formActiveState && (
        <div className="pop-up-screen">
          <>
            {React.cloneElement(children, {
              onClose: handleClose,
              onSuccess: handleSuccess,
              onError: handleError,
            })}
          </>
        </div>
      )}

      {showSuccessFormMessage && (
        <>
          <PopUpSuccessMessageModal
            successForm={successForm}
            showSuccessFormMessage={showSuccessFormMessage}
            setShowSuccessFormMessage={setShowSuccessFormMessage}
          />
        </>
      )}
    </>
  );

  return ReactDOM.createPortal(formModal, document.body);
};

export default PopUpModal;
